module.exports = __webpack_public_path__ + "img/image9.037af0f3.png";